import { useState, useEffect } from 'react';
import { useTranslation } from 'Shared/util/custom-hooks';
import makeComponentTrashable from 'trashable-react';
import PropTypes from 'prop-types';
import { fetchPriceInformation } from 'Shared/util/web-api';
import { formatAmount, formatDate } from 'Shared/util/formatters';
import Page from 'Shared/components/page/page';
import PricingMatrixTable from './tables/pricing-matrix-table';
import PriceHistoryTable from './tables/price-history-table';
import styles from './price-page.css';
import useCustomerContext from 'Contexts/customer-context';
import { useHistory } from 'react-router-dom';


const renderProperty = (label, value) => (
  <div className={styles.property}>
    <span>{label}</span>
    <span>{value}</span>
  </div>
);


const PricePage = ({
  registerPromise,
}) => {
  const [loading, setLoading] = useState(true);
  const [priceInformation, setPriceInformation] = useState({});
  const t = useTranslation(x => x.my_price);
  const { customerData } = useCustomerContext();
  const navigate = useHistory()
  
  useEffect(() => {
    if(customerData.serviceId !== 4 && customerData.serviceId !== undefined){
      navigate.push("/")
    }
  },[customerData])

  useEffect(() => {
    registerPromise(fetchPriceInformation())
      .then((result) => {
        setPriceInformation(result);
        setLoading(false)
      })
  }, []);

  const {
    summary,
    pricingMatrix,
    priceHistory,
  } = priceInformation;

  const showAgreedVolume = (!loading && summary.agreedVolume !== null);

  return (
    <Page
      narrowWidth
      title={t.my_price}
      loading={loading}
    >
      {loading == false && (<>
        <div className={styles.contentContainer}>
          <div className={styles.summarySection}>
            <div className={styles.introductionText}>
              {t.introduction}
            </div>
            {renderProperty(`${t.my_current_price}:`, `${formatAmount(summary.currentPrice)} %`)}
            {renderProperty(`${t.credit_volume_365_days}:`, `${formatAmount(summary.creditVolumeSoldLastYear)} kr`)}
            {showAgreedVolume && renderProperty(`${t.format(t.my_agreed_period_volume, { startDate: formatDate(summary.agreedVolumeStartDate), endDate: formatDate(summary.agreedVolumeEndDate) })}:`, `${formatAmount(summary.agreedVolume)} kr`)}
            {renderProperty(`${t.number_of_approved_guarantors}:`, `${summary.approvedGuarantors} st`)}
          </div>
          <div>
            <h4>{t.price_matrix}</h4>
            <PricingMatrixTable
              rows={pricingMatrix}
              translations={t.columns}
            />
          </div>
          <div>
            <h4>{t.price_history}</h4>
            <PriceHistoryTable
              rows={priceHistory}
              translations={t.columns}
            />
          </div>
        </div>
      </>)}
    </Page>
  );
};

PricePage.propTypes = {
  registerPromise: PropTypes.func.isRequired,
};

export default makeComponentTrashable(PricePage);
